<template>
  <div ref="app">
    <Header />
    <Hero />
    <DecorationItem />
    <Countdown />
    <Info />
    <Footer />
    <NewsletterForm />
    <Griddle />
  </div>
</template>

<script>
import gsap from "gsap";
import Header from "@/components/Header.vue";
import Hero from "@/components/Hero.vue";
import DecorationItem from "@/components/DecorationItem.vue";
import Countdown from "@/components/Countdown.vue";
import NewsletterForm from "@/components/NewsletterForm.vue";
import Info from "@/components/Info.vue";
import Footer from "@/components/Footer.vue";
export default {
  name: "App",
  components: {
    Header,
    Hero,
    DecorationItem,
    Countdown,
    Footer,
    NewsletterForm,
    Info,
  },
  props: {
    language: undefined,
  },
  methods: {
    show() {
      if (!this.$store.getters.textbooklet) return;
      //
      document.title = this.$store.getters.textbooklet[this.lang].title;
      //
      gsap.set(this.$refs.app, { alpha: 0 });
      gsap.to(this.$refs.app, { duration: 1, alpha: 1 });
    },
  },
  computed: {
    lang() {
      return this.$store.getters.lang;
    },
  },
  watch: {
    language() {},
    lang() {
      document.documentElement.lang = this.lang;
      this.show();
    },
  },
  mounted() {
    if (this.language === "ar") {
      this.$store.commit("set_lang", "ar");
    }

    this.$nextTick(() => {
      gsap.set(this.$refs.app, { alpha: 0 });
    });

    this.$http
      .get("contents.json")
      .then((response) => {
        this.$store.commit("set_tb", response.data);
        this.show();
      })
      .catch((error) => console.log(error));
  },
};
</script>
